/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsCollection = {
  init: function($section) {

    // Collection description read more only needs DOM inside the section (runs before section JSON parse).
    if (window.PXUTheme.collectionDescriptionReadMore && $section && $section[0]) {
      window.PXUTheme.collectionDescriptionReadMore.initScope($section[0]);
    }

    // Add settings from schema to current object
    window.PXUTheme.jsCollection = $.extend(this, window.PXUTheme.getSectionData($section));

    // function to check if browser is IE
    var isIE11 = !!navigator.userAgent.match(/Trident.*rv\:11\./);

    // Ensure product media libraries are present
    if (!isIE11) {
      window.Shopify.loadFeatures([
        {
          name: 'shopify-xr',
          version: '1.0',
        },
        {
          name: 'model-viewer-ui',
          version: '1.0',
        }
      ],)
    }

    if (this.enable_sorting == true) {
      $('#sort-by').val($('#sort-by').data('default-sort'));
    }

    if (this.enable_filter == true || this.enable_sorting == true) {
      $('#tag_filter, #sort-by').on('change', function() {
        window.PXUTheme.jsCollection.filterURL();
      });
    }

    if ($('[data-option-filter]').length) {
      // Show enabled filter tags based on selected checkboxes
      $('[data-tag-filter-checkbox]:checked').each(function(){
        window.PXUTheme.jsCollection.multiTagFilter.showSelectedFilter($(this));
      })
    }

    // If breadcrumbs enabled and basic pagination is set, call breadcrumbs object
    if (this.enable_breadcrumb && this.pagination_type == 'basic_pagination') {
      window.PXUTheme.breadcrumbs.init(this.number_of_pages);
    }

    /* Collection sidebar filter */
    $('body').on('click', '[data-option-filter]', function(e) {
      e.preventDefault();

      $(this).find('input').prop('checked', true);

      window.PXUTheme.jsCollection.multiTagFilter.init($(this));
      window.PXUTheme.scrollToTop($('.collection__content'));
    });

    $('body').on('click', '[data-clear-filter]', function () {
      const $el = $(this).siblings('[data-option-filter]');
      const $productTagFilter = $('#tag_filter');

      $productTagFilter.find('option:eq(0)').prop('selected', true);
      window.PXUTheme.jsCollection.multiTagFilter.clearSelectedFilter($el);
      window.PXUTheme.scrollToTop($('.collection__content'));

    });
  },
  filterURL: function() {

    var selectedOptions = [],
        query = '',
        currentTags = '',
        siteUrl = 'https://' + $.url('hostname');

    // check if language has been translated. Length equals one when default language (eg: '/') and greater than 1 when language is translated (eg: '/fr')
    if (window.PXUTheme.routes.root_url.length > 1) {
      var url1 = $.url('1') ? '/' + $.url('1') + '/' : '';
      var url2 = $.url('2') ? $.url('2') + '/' : '';
      var url3 = $.url('3') ? $.url('3') + '/' : '';
      var path = url1 + url2 + url3;
    } else {
      var url1 = $.url('1') ? '/' + $.url('1') + '/' : '';
      var url2 = $.url('2') ? $.url('2') + '/' : '';
      var path = url1 + url2;
    }

    //Handle dropdowns if they exist
    if ($('#sort-by').length){
      query = $('#sort-by').val();
    } else {
      query = url('?sort_by');
    }

    if ($('#tag_filter').length){

      if ($('#tag_filter').data('default-collection') != $('#tag_filter').val()){
        var urlTag = $('#tag_filter').val().substr($('#tag_filter').val().lastIndexOf('/') + 1);

        if (urlTag != 'all'){
          if ($.inArray( urlTag, selectedOptions ) > -1){
            //Do nothing
          } else {
            selectedOptions.unshift(urlTag);
          }
        }
      }
    }

    //Add all checkbox values to array
    $('[data-option-filter] input:checked').each(function () {
      selectedOptions.push($(this).val());
    });

    selectedOptions = $.makeArray(selectedOptions);

    //Loop through tags to create string to update page url
    $.each(selectedOptions, function(i, value){

      if (i != selectedOptions.length - 1) {
        currentTags += selectedOptions[i] + '+';
      } else {
        currentTags += selectedOptions[i];
      }

    });

    window.PXUTheme.queryParameters.sort_by = query;
    query = '?' + $.param(window.PXUTheme.queryParameters);

    this.processUrl(path, currentTags, query);
  },
  processUrl: function (path, tags, query) {

    var query = query.replace(/\page=(\w+)&/, ''),
      urlString = '';

    urlString = path + tags + query;

    this.updateView(urlString);

  },
  updateView: function(filterURL) {
    $.ajax({
      type: 'GET',
      url: filterURL,
      beforeSend: function() {
        $('.collection-matrix').addClass('fadeOut animated loading-in-progress');
        $('.collection-matrix__wrapper .collection__loading-icon').fadeIn();
      },
      success: function(data) {
      },
      error: function(x, t, m) {
        console.log(x);
        console.log(t);
        console.log(m);
        location.replace(location.protocol + '//' + location.host + filterURL);

      },
      dataType: "html"
    }).then(function(data){

      const $breadcrumbContainer = $('.breadcrumb__container');
      const $collectionMatrix = $('.collection-matrix');
      const $collectionMain = $('[data-collection-main]');

      // Get and set new breadcrumb html
      const filteredBreadcrumb = $(data).find('.breadcrumb__container').html();
      $breadcrumbContainer.html(filteredBreadcrumb);

      // Remove loading animation
      $collectionMatrix.removeClass('fadeIn animated loading-in-progress');

      // Check for products
      const filteredData = $(data).find('.collection-matrix__wrapper');
      const filteredPageLinks = $(data).find('.container--pagination');
      const noProducts = $(data).find('.container--no-products-in-collection');

      if (filteredData.length) {
        // Add products to container
        $collectionMain.empty();
        $collectionMain.append(filteredData);
      } else {
        // Display no product message
        $collectionMain.empty();
        $collectionMain.append(noProducts);
      }

      $collectionMain.append(filteredPageLinks);

      window.history && window.history.pushState && window.history.pushState("", "", filterURL);

      // Initiate infinite scrolling on new products appended to collection grid
      if ($('[data-custom-pagination]').length) {
        window.PXUTheme.infiniteScroll.init();
      }

    });
  },
  multiTagFilter: {
    init: function ($el) {

      // Show filter and hide siblings
      this.showSelectedFilter($el);

      // Update url
      window.PXUTheme.jsCollection.filterURL();

      var urlIndex;
      if (window.PXUTheme.routes.root_url.length > 1) {
        urlIndex = 3
      } else {
        urlIndex = 2
      }

      // Hide filters if types or vendors is in URL (can't be combined)
      if ($.url(urlIndex) === 'types' || $.url(urlIndex) === 'vendors') {
        $('.block__tag-filter').remove();
      }

    },
    showSelectedFilter: function ($el) {
      const $sidebarToggleBlock = $el.parents('.sidebar-toggle-active');
      const $filterItem = $el.parents('.tag-filter__item');

      $filterItem.addClass('is-active');
      $filterItem.siblings(':not(.is-active)').addClass('is-hidden');
      $filterItem.find('[data-clear-filter]').removeClass('is-hidden');

      // If sidebar toggle is enabled, show filter in sidebar content
      if ($sidebarToggleBlock.length) {
        let $toggleBtn = $sidebarToggleBlock.find('[data-sidebar-block__toggle="closed"]');

        window.PXUTheme.jsSidebar.openSidebarBlock($toggleBtn);
      }

    },
    clearSelectedFilter: function ($el) {

      const $filterItem = $el.parents('.tag-filter__item');

      $filterItem.removeClass('is-active')
            .find('input').prop("checked", false);
      $filterItem.siblings()
            .removeClass('is-hidden');
      $filterItem.find('[data-clear-filter]')
            .addClass('is-hidden');

      //Update url
      window.PXUTheme.jsCollection.filterURL();
    }
  },
  unload: function($section) {
    $('#tag_filter, #sort-by').off();
    $('[data-option-filter]').off();
    $('[data-reset-filters]').off();
    $('[data-clear-filter]').off();
    window.PXUTheme.breadcrumbs.unload();
  if (window.PXUTheme.collectionDescriptionReadMore) {
      window.PXUTheme.collectionDescriptionReadMore.unloadScope($section[0]);
    }
  }
}

/**
 * Collection description read more — DOM preserved, max-height collapse/expand.
 * Timing/easing live in sections/collection__main.liquid (`read_more_transition_s` + scoped CSS).
 * JS sets heights and toggles is-read-more--instant for reflow snaps without animating.
 */
window.PXUTheme.collectionDescriptionReadMore = (function () {
  var MOBILE_MQ = '(max-width: 798px)';
  var TRANSITION_MS_FALLBACK = 660;
  var SCROLL_HEIGHT_TOLERANCE_PX = 8;
  var EXPAND_HEIGHT_EPSILON_PX = 4;
  var COLLAPSED_HEIGHT_TOLERANCE_PX = 2;

  function parseDatasetBool(v) {
    return v === true || v === 'true';
  }

  function parseWords(v, fallback) {
    var n = parseInt(v, 10);
    if (!isFinite(n) || n < 1) {
      return fallback;
    }
    return n;
  }

  function countWordsInElement(el) {
    var t = (el && el.textContent) || '';
    var m = t.match(/\S+/g);
    return m ? m.length : 0;
  }

  function lineHeightPx(el) {
    var lh = parseFloat(window.getComputedStyle(el).lineHeight);
    if (isFinite(lh) && lh > 2) {
      return lh;
    }
    var fs = parseFloat(window.getComputedStyle(el).fontSize) || 16;
    return fs * 1.5;
  }

  function wordsToPreviewLines(wordLimit, isMobile) {
    var perLine = isMobile ? 6 : 11;
    return Math.max(2, Math.min(50, Math.ceil(wordLimit / perLine)));
  }

  function collapsedPxFromBudget(contentEl, lineBudget) {
    return Math.ceil(lineHeightPx(contentEl) * lineBudget);
  }

  function clearCollapse(contentEl) {
    contentEl.classList.remove('is-read-more--collapsed', 'is-read-more--expanded', 'is-read-more--instant');
    contentEl.style.maxHeight = '';
    contentEl.style.overflow = '';
  }

  function initOne(wrapper) {
    if (wrapper.getAttribute('data-read-more-initialized') === 'true') {
      return;
    }

    var content = wrapper.querySelector('[data-collection-description-content]');
    var button = wrapper.querySelector('.read-more-toggle');
    if (!content || !button) {
      return;
    }

    if (!((content.textContent || '').replace(/\s/g, ''))) {
      return;
    }

    wrapper.setAttribute('data-read-more-initialized', 'true');

    var readMoreLabel = button.getAttribute('data-read-more-label') || 'Read more';
    var readLessLabel = button.getAttribute('data-read-less-label') || 'Read less';
    var mqMobile = window.matchMedia(MOBILE_MQ);
    var expanded = false;
    var animating = false;
    var resizeTimer;
    var lineBudget = 4;
    var canToggle = false;
    var animTimer = null;
    var animTeHandler = null;
    var transitionMs = (function () {
      var n = parseInt(wrapper.getAttribute('data-read-more-transition-ms'), 10);
      return isFinite(n) && n > 0 ? n : TRANSITION_MS_FALLBACK;
    })();

    function cancelAnim() {
      if (animTimer !== null) {
        window.clearTimeout(animTimer);
        animTimer = null;
      }
      if (animTeHandler) {
        content.removeEventListener('transitionend', animTeHandler);
        animTeHandler = null;
      }
    }

    function readConfig() {
      return {
        enableMobile: parseDatasetBool(wrapper.dataset.enableMobile),
        enableDesktop: parseDatasetBool(wrapper.dataset.enableDesktop),
        mobileWords: 10,
        desktopWords: 10
      };
    }

    function viewportMobile() {
      return mqMobile.matches;
    }

    function featureEnabled(cfg) {
      return viewportMobile() ? cfg.enableMobile : cfg.enableDesktop;
    }

    function activeWordLimit(cfg) {
      return viewportMobile() ? cfg.mobileWords : cfg.desktopWords;
    }

    function hideButtonAndResetContent() {
      clearCollapse(content);
      button.setAttribute('hidden', '');
      button.setAttribute('aria-expanded', 'false');
      button.textContent = readMoreLabel;
    }

    function applyCollapsedInstant(contentEl, budget) {
      var px = collapsedPxFromBudget(contentEl, budget);
      var computedMax = parseFloat(window.getComputedStyle(contentEl).maxHeight);
      var hasEquivalentComputedMax = isFinite(computedMax) && Math.abs(computedMax - px) <= COLLAPSED_HEIGHT_TOLERANCE_PX;
      var inlineMax = parseFloat(contentEl.style.maxHeight);
      var hasEquivalentInlineMax = isFinite(inlineMax) && Math.abs(inlineMax - px) <= COLLAPSED_HEIGHT_TOLERANCE_PX;
      var alreadyCollapsed = contentEl.classList.contains('is-read-more--collapsed') && !contentEl.classList.contains('is-read-more--expanded');
      var needsLayoutFlush = !alreadyCollapsed || (!hasEquivalentInlineMax && !hasEquivalentComputedMax) || contentEl.style.overflow !== 'hidden';

      contentEl.classList.add('is-read-more--instant');
      contentEl.classList.remove('is-read-more--expanded');
      contentEl.classList.add('is-read-more--collapsed');
      contentEl.style.overflow = 'hidden';
      contentEl.style.maxHeight = px + 'px';

      if (needsLayoutFlush) {
        void contentEl.offsetHeight;
      }

      contentEl.classList.remove('is-read-more--instant');
    }

    function runMaxHeightTransition(fromPx, toPx, onComplete) {
      var done = false;
      function finish() {
        if (done) {
          return;
        }
        done = true;
        cancelAnim();
        onComplete();
      }

      content.classList.add('is-read-more--instant');
      content.style.overflow = 'hidden';
      content.style.maxHeight = fromPx + 'px';
      void content.offsetHeight;
      content.classList.remove('is-read-more--instant');
      content.style.maxHeight = toPx + 'px';

      animTeHandler = function (e) {
        if (e.propertyName === 'max-height') {
          finish();
        }
      };
      content.addEventListener('transitionend', animTeHandler);
      animTimer = window.setTimeout(finish, transitionMs);
    }

    function sync() {
      cancelAnim();
      animating = false;
      canToggle = false;
      var cfg = readConfig();
      expanded = false;

      if (!featureEnabled(cfg)) {
        hideButtonAndResetContent();
        return;
      }

      var wordLimit = activeWordLimit(cfg);
      var totalWords = countWordsInElement(content);

      if (totalWords <= wordLimit) {
        hideButtonAndResetContent();
        return;
      }

      lineBudget = wordsToPreviewLines(wordLimit, viewportMobile());
      applyCollapsedInstant(content, lineBudget);

      window.requestAnimationFrame(function () {
        if (content.scrollHeight <= content.clientHeight + SCROLL_HEIGHT_TOLERANCE_PX) {
          hideButtonAndResetContent();
          return;
        }

        canToggle = true;
        button.removeAttribute('hidden');
        button.setAttribute('aria-expanded', 'false');
        button.textContent = readMoreLabel;
      });
    }

    function finishExpand() {
      content.classList.add('is-read-more--instant');
      content.classList.remove('is-read-more--collapsed');
      content.classList.add('is-read-more--expanded');
      content.style.maxHeight = 'none';
      content.style.overflow = '';
      void content.offsetHeight;
      content.classList.remove('is-read-more--instant');
      animating = false;
      expanded = true;
      button.setAttribute('aria-expanded', 'true');
      button.textContent = readLessLabel;
    }

    function runExpand() {
      if (animating) {
        return;
      }
      cancelAnim();
      animating = true;
      var startH = content.clientHeight;
      var endH = content.scrollHeight;
      if (endH <= startH + EXPAND_HEIGHT_EPSILON_PX) {
        finishExpand();
        return;
      }

      runMaxHeightTransition(startH, Math.ceil(endH) + 2, finishExpand);
    }

    function finishCollapse(targetPx) {
      content.classList.add('is-read-more--instant');
      content.classList.add('is-read-more--collapsed');
      content.classList.remove('is-read-more--expanded');
      content.style.overflow = 'hidden';
      content.style.maxHeight = targetPx + 'px';
      void content.offsetHeight;
      content.classList.remove('is-read-more--instant');
      animating = false;
      expanded = false;
      button.setAttribute('aria-expanded', 'false');
      button.textContent = readMoreLabel;
    }

    function runCollapse() {
      if (animating) {
        return;
      }
      cancelAnim();
      animating = true;
      var targetPx = collapsedPxFromBudget(content, lineBudget);
      var fullH = Math.max(content.scrollHeight, content.clientHeight);

      content.classList.add('is-read-more--collapsed');
      content.classList.remove('is-read-more--expanded');
      runMaxHeightTransition(fullH, targetPx, function () {
        finishCollapse(targetPx);
      });
    }

    var onClick = function () {
      if (!canToggle || animating) {
        return;
      }

      if (expanded) {
        runCollapse();
      } else {
        runExpand();
      }
    };

    var onResize = function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        expanded = false;
        sync();
      }, 120);
    };

    var onMqChange = function () {
      expanded = false;
      sync();
    };

    button.addEventListener('click', onClick);
    window.addEventListener('resize', onResize);
    if (mqMobile.addEventListener) {
      mqMobile.addEventListener('change', onMqChange);
    } else if (mqMobile.addListener) {
      mqMobile.addListener(onMqChange);
    }

    wrapper._readMoreTeardown = function () {
      cancelAnim();
      window.clearTimeout(resizeTimer);
      button.removeEventListener('click', onClick);
      window.removeEventListener('resize', onResize);
      if (mqMobile.removeEventListener) {
        mqMobile.removeEventListener('change', onMqChange);
      } else if (mqMobile.removeListener) {
        mqMobile.removeListener(onMqChange);
      }
      clearCollapse(content);
      canToggle = false;
      expanded = false;
      animating = false;
      button.setAttribute('hidden', '');
      button.setAttribute('aria-expanded', 'false');
      button.textContent = readMoreLabel;
      wrapper.removeAttribute('data-read-more-initialized');
      wrapper._readMoreTeardown = null;
    };

    sync();

  }

  return {
    initScope: function (rootEl) {
      if (!rootEl || !rootEl.querySelectorAll) {
        return;
      }
      var wrappers = rootEl.querySelectorAll('[data-collection-read-more]');
      for (var w = 0; w < wrappers.length; w++) {
        initOne(wrappers[w]);
      }
    },

    unloadScope: function (rootEl) {
      if (!rootEl || !rootEl.querySelectorAll) {
        return;
      }
      var wrappers = rootEl.querySelectorAll('[data-collection-read-more]');
      for (var i = 0; i < wrappers.length; i++) {
        if (wrappers[i]._readMoreTeardown) {
          wrappers[i]._readMoreTeardown();
        }
      }
    }
  };
})();

if (!window.PXUTheme._collectionDescriptionReadMoreSectionLoad) {
  window.PXUTheme._collectionDescriptionReadMoreSectionLoad = true;
  document.addEventListener('shopify:section:load', function (e) {
    var id = e.detail && e.detail.sectionId;
    if (!id || !window.PXUTheme.collectionDescriptionReadMore) {
      return;
    }
    var node = document.getElementById('shopify-section-' + id);
    if (!node) {
      return;
    }
    window.requestAnimationFrame(function () {
      window.PXUTheme.collectionDescriptionReadMore.initScope(node);
    });
  });
}

/******/ })();